import { render, staticRenderFns } from "./supportCenter.html?vue&type=template&id=ba0192fa&scoped=true&external"
import script from "./supportCenter.js?vue&type=script&lang=js&external"
export * from "./supportCenter.js?vue&type=script&lang=js&external"
import style0 from "./supportCenter.scss?vue&type=style&index=0&id=ba0192fa&prod&scoped=true&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=ba0192fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0192fa",
  null
  
)

export default component.exports